<template>
  <v-container fluid px-0 py-2 class="Container_Nivel1_Notas">
    <v-card class="mb-4" v-for="card in listaCards" :key="card.titulo">
      <v-card-title>
        <span class="font-weight-black"> {{ card.titulo }} </span>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon @click="card.abrirFiltro = !card.abrirFiltro" v-bind="attrs" v-on="on">
              <v-icon>get_app</v-icon>
            </v-btn>
          </template>
          {{ $t('label.exportar') }}
        </v-tooltip>
      </v-card-title>
      <v-expand-transition>
        <v-card v-show="card.abrirFiltro" class="elevation-0">
          <div class="pa-5">
            <v-row v-if ="isSellin(card)" >
              <v-col cols="12" md="6" sm="12" lg="6">
                <v-select
                  item-text="text"
                  item-value="value"
                  v-model="filtroSellin.tipoData"
                  :items="listaTiposDataSellin"
                  :label="`${$tc('label.aplicar_se_a', 1)} *`">
                </v-select>
              </v-col>
              <v-col cols="12" md="6" sm="12" lg="6">
                <v-select
                  item-text="text"
                  item-value="value"
                  v-model="filtroSellin.tipoNota"
                  :rules="[rules.required]"
                  :items="getListaTipoNota()"
                  :label="`${$tc('label.agrupamento', 1)} *`">
                </v-select>
              </v-col>
              <v-col cols="12" md="6" sm="12" lg="6">
                <v-autocomplete
                  id="filtro-autocomplete-grupo-fornecedor"
                  class="custom-autocomplete"
                  v-model="filtroSellin.grupoFornecedor"
                  :items="gruposFornecedores"
                  :label="`${$tc('label.grupo_fornecedor', 1)}`"
                  :placeholder="$tc('label.digite_para_buscar', 1)"
                  :no-data-text="$tc('message.nenhum_registro', 1)"
                  item-text="nomExtensao"
                  item-value="id"
                  :clearable="true"
                  return-object
                  @click:append="() => triggerSelecao('filtro-autocomplete-grupo-fornecedor')"
                  @click.native="(i) => buscaAutocomplete(i, buscaGruposFornecedores)"
                  @update:search-input="(val) => triggerGrupoFornecedor(val, card)">
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="6" sm="12" lg="6">
                <v-autocomplete
                  id="filtro-autocomplete-fornecedor"
                  class="custom-autocomplete"
                  v-model="filtroSellin.fornecedor"
                  :filter="filtrarFornecedores"
                  :items="fornecedores"
                  :label="`${$tc('label.fornecedor', 1)}`"
                  :placeholder="$tc('label.digite_para_buscar', 1)"
                  :no-data-text="$tc('message.nenhum_registro', 1)"
                  item-text="razaoSocial"
                  item-value="id"
                  :clearable="true"
                  return-object
                  @click:append="() => triggerSelecao('filtro-autocomplete-fornecedor')"
                  @click.native="(i) => buscaAutocomplete(i, () => buscaFornecedores(i, card))"
                  @update:search-input="(val) => triggerFornecedor(val, card)">
                </v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-date-picker
                  locale="pt-br"
                  v-model="months"
                  full-width
                  type="month"
                  no-title
                  multiple
                  color="primary">
                </v-date-picker>
              </v-col>
              <v-col cols="12" class="d-flex justify-end">
                <v-btn text color="primary"
                  @click.native="card.abrirFiltro = false">
                  {{ $t('label.cancelar') }}
                </v-btn>
                <v-btn text color="primary"
                  @click.native="abrirModalConfirmacao('exportar', card)">
                  {{ $t('label.confirmar') }}
                </v-btn>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="12" md="6" sm="12" lg="6">
                <v-select
                  item-text="text"
                  item-value="value"
                  v-model="filtroSellout.tipoData"
                  :items="listaTiposDataSellout"
                  :label="`${$tc('label.aplicar_se_a', 1)} *`">
                </v-select>
              </v-col>
              <v-col cols="12" md="6" sm="12" lg="6">
                <v-select
                  item-text="text"
                  item-value="value"
                  v-model="filtroSellout.tipoNota"
                  :rules="[rules.required]"
                  :items="listaTiposNotaSellout"
                  :label="`${$tc('label.agrupamento', 1)} *`">
                </v-select>
              </v-col>
              <v-col cols="12" md="6" sm="12" lg="6">
                <v-autocomplete
                  id="filtro-autocomplete-grupo-fornecedor"
                  class="custom-autocomplete"
                  v-model="filtroSellout.grupoFornecedor"
                  :items="gruposFornecedores"
                  :rules="[rules.required]"
                  :label="`${$tc('label.grupo_fornecedor', 1)} *`"
                  :placeholder="$tc('label.digite_para_buscar', 1)"
                  :no-data-text="$tc('message.nenhum_registro', 1)"
                  item-text="nomExtensao"
                  item-value="id"
                  :clearable="true"
                  return-object
                  @click:append="() => triggerSelecao('filtro-autocomplete-grupo-fornecedor')"
                  @click.native="(i) => buscaAutocomplete(i, buscaGruposFornecedores)"
                  @update:search-input="(val) => triggerGrupoFornecedor(val, card)">
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="6" sm="12" lg="6">
                <v-autocomplete
                  id="filtro-autocomplete-fornecedor-sellout"
                  class="custom-autocomplete"
                  v-model="filtroSellout.fornecedor"
                  :filter="filtrarFornecedores"
                  :items="fornecedoresSellout"
                  :label="`${$tc('label.fornecedor', 1)}`"
                  :placeholder="$tc('label.digite_para_buscar', 1)"
                  :no-data-text="$tc('message.nenhum_registro', 1)"
                  item-text="razaoSocial"
                  item-value="id"
                  :clearable="true"
                  return-object
                  @click:append="() => triggerSelecao('filtro-autocomplete-fornecedor-sellout')"
                  @click.native="(i) => buscaAutocomplete(i, () => buscaFornecedores(i, card))"
                  @update:search-input="(val) => triggerFornecedor(val, card)">
                </v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-autocomplete
                  id="filtro-autocomplete-categoria"
                  class="custom-autocomplete"
                  v-model="filtroSellout.categoria"
                  :items="listaCategorias"
                  :rules="[rules.required]"
                  :label="`${$tc('label.categoria', 1)} *`"
                  :placeholder="$tc('label.digite_para_buscar', 1)"
                  :no-data-text="$tc('message.nenhum_registro', 1)"
                  item-text="codNomeCategoria"
                  item-value="id"
                  :clearable="true"
                  return-object
                  @click:append="() => triggerSelecao('filtro-autocomplete-categoria')"
                  @click.native="(i) => buscaAutocomplete(i, buscaCategorias)"
                  :search-input.sync="triggerCategoria">
                </v-autocomplete>
              </v-col>
              <v-col cols="12" lg="6" md="6" sm="12">
                <v-date-picker
                locale="pt-br"
                full-width
                v-model="dateRange"
                type="date"
                no-title
                range
                @input="validarIntervalo"
                color="primary">
                </v-date-picker>
              </v-col>
              <v-col cols="12" lg="6" md="6" sm="12">
                <v-data-table
                  id="produto_tabela"
                  :headers="headersProduto"
                  :items="listaProdutosSelecionados"
                  hide-default-footer
                  disable-pagination
                  fixed-header
                  :height="listaProdutosSelecionados.length > 7 ? 48 * 7 - 1 : undefined"
                  :no-data-text="$t('message.nenhum_registro')">
                  <template v-slot:top>
                    <v-autocomplete
                    id="filtro-autocomplete-sku"
                    class="custom-autocomplete"
                    v-model="filtroNomeProduto"
                    hide-details
                    dense
                    outlined
                    :filter="filtrarProdutos"
                    :items="listaProdutos"
                    :disabled="!filtroSellout.categoria || !filtroSellout.grupoFornecedor"
                    return-object
                    @change="setProduto"
                    :label="`${$tc('label.sku', 1)}`"
                    :placeholder="$tc('label.digite_para_buscar', 1)"
                    :no-data-text="$tc('message.nenhum_registro', 1)"
                    item-text="codNomeProduto"
                    item-value="id"
                    :item-disabled="validaListaProduto"
                    :clearable="true"
                    @click:append="() => triggerSelecao('filtro-autocomplete-sku')"
                    @click.native="(i) => buscaAutocomplete(i, buscaProdutos)"
                    :search-input.sync="triggerProduto">
                      <template slot="item" slot-scope="data">
                        {{ data.item.codNomeProduto }}
                      </template>
                    </v-autocomplete>
                  </template>
                  <template v-slot:item.acoes="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn icon v-on="on" @click="removerProdutoPeloId(item.id)">
                          <v-icon>delete</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t('label.remover') }}</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-col>
              <v-col cols="12" class="d-flex justify-end">
                <v-btn text color="primary"
                  @click.native="card.abrirFiltro = false">
                  {{ $t('label.cancelar') }}
                </v-btn>
                <v-btn text color="primary"
                  @click.native="abrirModalConfirmacao('exportar', card)">
                  {{ $t('label.confirmar') }}
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-card>
      </v-expand-transition>
    </v-card>
    <confirm
      ref="modalConfirmacao"
      :message="mensagemConfirmacao"
      @agree="confirmaExportacao"
      @disagree="cancelarExportacao">
    </confirm>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { getMoney, copyObject } from '@/common/functions/helpers';
import { generateComputed } from '@/common/functions/roles-computed-generator';
import Confirm from '@/shared-components/dialog/Confirm';
import { buscaAutocomplete, triggerSelecao } from '@/common/functions/autocomplete-utils';
import { executarExportacao, verificarDadosExportacao } from '@/common/resources/solicitacao-exportacao-assincrona';

export default {
  name: 'NotasNivel1DadosAgrupado',
  components: {
    Confirm,
  },
  props: {
  },
  data() {
    return {
      resources: this.$api.notas(this.$resource),
      configSistemaResource: this.$api.configuracaoSistema(this.$resource),
      exportacaoAssincronaResource: this.$api.solicitacaoExportacaoAssincrona(this.$resource),
      planejamentoAcaoResource: this.$api.planejamentoAcaoCadastro(this.$resource),
      exportacaoAssincrona: null,
      listaCards: [
        {
          tipo: 'SELLIN',
          titulo: 'Sellin-Devoluções',
          ordenacao: 1,
          abrirFiltro: false,
        },
        {
          tipo: 'SELLOUT',
          titulo: 'Sellout-Devoluções',
          ordenacao: 2,
          abrirFiltro: false,
        },
      ],
      esperar: false,
      rules: {
        required: (value) => (!!value || value === 0) || this.$t('message.campo_obrigatorio'),
      },
      menu: [
        false,
        false,
        false,
      ],
      date: new Date().toISOString().substr(0, 10),
      mensagemConfirmacao: '',
      bloquearBotaoExportacao: false,
      notaSelecionada: {},
      months: [],
      dateRange: [],
      triggerCategoria: null,
      triggerProduto: null,
      fornecedores: [],
      fornecedoresSellout: [],
      gruposFornecedores: [],
      listaCategorias: [],
      listaProdutos: [],
      listaProdutosSelecionados: [],
      headersProduto: [
        {
          text: '', value: 'acoes', width: '2%', sortable: false,
        },
        { text: this.$tc('label.cod_produto', 1), width: '30%', value: 'id' },
        { text: this.$tc('label.nome_produto', 1), width: '60%', value: 'codNomeProduto' },
      ],
      filtroNomeProduto: '',
      pagination: {
        page: 1,
        totalPage: 0,
        rowsPerPage: 10,
      },
      gruposProdutosSelecionados: [],
      filtro: {
        tipoData: 'dataConferencia',
        tipoNota: 'SELLIN_POR_LINHA',
        fornecedor: null,
        grupoFornecedor: null,
      },
      filtroSellin: {
        tipoData: 'dataConferencia',
        tipoNota: '',
        fornecedor: null,
        grupoFornecedor: null,
      },
      filtroSellout: {
        tipoData: 'dataCompetencia',
        tipoNota: 'SELLOUT_POR_LINHA',
        fornecedor: null,
        grupoFornecedor: null,
        categoria: null,
        produto: null,
      },
      listaTiposDataSellin: [
        { text: this.$tc('label.data_conferencia', 1), value: 'dataConferencia' },
        { text: this.$tc('label.data_emissao', 1), value: 'dataEmissao' },
      ],
      listaTiposDataSellout: [
        { text: this.$tc('label.data_competencia', 1), value: 'dataCompetencia' },
        { text: this.$tc('label.data_pedido', 1), value: 'dataPedido' },
      ],
      listaTiposNotaSellin: [
        { text: this.$tc('label.linha', 1), value: 'SELLIN_POR_LINHA' },
        { text: this.$tc('label.familia', 1), value: 'SELLIN_POR_FAMILIA' },
        { text: this.$tc('label.produto', 1), value: 'SELLIN_POR_PRODUTO' },
        { text: this.$tc('label.nota_fiscal_agrupada', 1), value: 'SELLIN_POR_NF' },
        { text: this.$tc('label.nota_fiscal_item', 1), value: 'SELLIN_POR_NF_ITEM' },
        { text: this.$tc('label.fornecedor', 1), value: 'SELLIN_POR_FORNECEDOR' },
      ],
      listaTiposNotaSellinEpoca: [
        { text: this.$tc('label.categoria', 1), value: 'SELLIN_POR_CATEGORIA' },
        { text: this.$tc('label.marca', 1), value: 'SELLIN_POR_MARCA' },
        { text: this.$tc('label.produto', 1), value: 'SELLIN_POR_PRODUTO' },
        { text: this.$tc('label.nota_fiscal_item', 1), value: 'SELLIN_POR_NF_ITEM' },
      ],
      listaTiposNotaSellinKabum: [
        { text: this.$tc('label.departamento', 1), value: 'SELLIN_POR_DEPARTAMENTO' },
        { text: this.$tc('label.familia', 1), value: 'SELLIN_POR_SECAO' },
        { text: this.$tc('label.produto', 1), value: 'SELLIN_POR_PRODUTO' },
        { text: this.$tc('label.nota_fiscal_item', 1), value: 'SELLIN_POR_NF_ITEM' },
      ],
      listaTiposNotaSellout: [
        { text: this.$tc('label.linha', 1), value: 'SELLOUT_POR_LINHA' },
        { text: this.$tc('label.familia', 1), value: 'SELLOUT_POR_FAMILIA' },
        { text: this.$tc('label.produto', 1), value: 'SELLOUT_POR_PRODUTO' },
        { text: this.$tc('label.numero_pedido_item', 1), value: 'SELLOUT_POR_PEDIDO_ITEM' },
      ],
    };
  },
  created() {
    this.filtroSellin.tipoNota = this.setTipoNota();
  },
  watch: {
    pagination: {
      handler() {
        this.filtrar();
      },
      deep: true,
    },
    triggerCategoria(val) {
      const { categoria } = this.filtro;
      this.listaProdutosSelecionados = [];
      this.listaProdutos = [];
      if (categoria && categoria.codNomeCategoria === val) {
        return;
      }
      if (this.timeoutTrigger) {
        window.clearTimeout(this.timeoutTrigger);
      }
      this.timeoutTrigger = window.setTimeout(() => {
        if (val != null) this.buscaCategorias(val);
      }, 500);
    },
    triggerProduto(val) {
      const { produto } = this.filtroSellout;
      if (produto && produto.codNomeProduto === val) {
        return;
      }
      if (this.timeoutTrigger) {
        window.clearTimeout(this.timeoutTrigger);
      }
      this.timeoutTrigger = window.setTimeout(() => {
        if (val != null) this.buscaProdutos(val);
      }, 500);
    },
  },
  computed: {
    ...generateComputed('NOTA', [
      'canAccessPage',
      'canAccessCRUD',
    ]),
    ...mapGetters('implantacao', [
      'chaveEmpresa',
    ]),
    isAmbienteMagalu() {
      return this.chaveEmpresa === 'MAGALU';
    },
    isAmbienteEpoca() {
      return this.chaveEmpresa === 'EPOCA';
    },
    isAmbienteKabum() {
      return this.chaveEmpresa === 'KABUM';
    },
    pages() {
      return Math.ceil(this.pagination.totalPage / this.pagination.rowsPerPage);
    },
    produtosPaginados() {
      const listaPaginada = copyObject(this.listaprodutos || []);
      const startFrom = (this.pagination.page * this.pagination.rowsPerPage) - this.pagination.rowsPerPage;
      return listaPaginada.splice(startFrom, this.pagination.rowsPerPage);
    },
  },
  methods: {
    getMoney,
    buscaAutocomplete,
    triggerSelecao,

    isSellout(nota) {
      return nota.tipo === 'SELLOUT';
    },
    isSellin(nota) {
      return nota.tipo === 'SELLIN';
    },
    selectItem() {
      // retirando acesso a tela de nivel 2 de notas
      // this.$emit('Notas__SelecionaItemNivel1', item);
    },
    getLabelValorLiquido() {
      if (this.isAmbienteMagalu) {
        return this.$t('label.valor_nf_ipi');
      }
      return this.$t('label.valor_liquido');
    },
    getListaTipoNota() {
      if (this.isAmbienteEpoca) {
        return this.listaTiposNotaSellinEpoca;
      }
      if (this.isAmbienteKabum) {
        return this.listaTiposNotaSellinKabum;
      }
      return this.listaTiposNotaSellin;
    },
    filtrar() {
      if (this.esperar) return;
      this.esperar = true;
      setTimeout(() => {
        this.buscar();
      }, 1000);
    },
    triggerGrupoFornecedor(val, item) {
      const filtro = this.isSellout(item) ? this.filtroSellout : this.filtroSellin;
      const { grupoFornecedor } = filtro;
      this.listaProdutosSelecionados = [];
      this.listaProdutos = [];
      if (this.isSellout(item)) {
        this.fornecedoresSellout = [];
      } else {
        this.fornecedores = [];
      }
      if (grupoFornecedor && grupoFornecedor.nomExtensao === val) {
        return;
      }
      if (this.timeoutTrigger) {
        window.clearTimeout(this.timeoutTrigger);
      }
      this.timeoutTrigger = window.setTimeout(() => {
        if (val != null) this.buscaGruposFornecedores(val);
      }, 500);
    },
    triggerFornecedor(val, item) {
      const filtro = this.isSellout(item) ? this.filtroSellout : this.filtroSellin;
      const { fornecedor } = filtro;
      this.listaProdutosSelecionados = [];
      this.listaProdutos = [];
      if (fornecedor && fornecedor.razaoSocial === val) {
        return;
      }
      if (this.timeoutTrigger) {
        window.clearTimeout(this.timeoutTrigger);
      }
      this.timeoutTrigger = window.setTimeout(() => {
        if (val != null) {
          this.buscaFornecedores(val, item);
        }
      }, 500);
    },
    buscar() {
      this.resources.listarNotasAgrupadasPorTipo().then((response) => {
        this.listaCards = response.data;
        this.pararEsperar();
      }, (err) => {
        this.pararEsperar();
        this.$error(this, err);
      });
    },
    pararEsperar() {
      setTimeout(() => {
        this.esperar = false;
      }, 2E2);
    },
    filtrarFornecedores(item, queryText) {
      return item.codNomeCnpj.toLowerCase().indexOf(queryText.toLowerCase()) > -1
        || item.desCnpj.replace(/[./-]/g, '').indexOf(queryText) > -1;
    },
    filtrarProdutos(item, queryText) {
      return item.codNomeProduto.toLowerCase().indexOf(queryText.toLowerCase()) > -1
        || item.id.indexOf(queryText) > -1;
    },
    buscaGruposFornecedores(autocomplete) {
      const parametros = {
        autocomplete,
      };
      this.planejamentoAcaoResource.buscarGruposFornecedores(parametros)
        .then((res) => {
          this.gruposFornecedores = res.data;
        })
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    buscaFornecedores(autocomplete, item) {
      const parametros = {
        autocomplete,
        pagador: false,
        indAtivo: true,
      };
      const filtro = this.isSellout(item) ? this.filtroSellout : this.filtroSellin;
      if (filtro.grupoFornecedor) {
        parametros.idGrupoFornecedor = filtro.grupoFornecedor.id;
      }
      this.planejamentoAcaoResource.buscarFornecedores(parametros)
        .then((res) => {
          if (this.isSellout(item)) {
            this.fornecedoresSellout = res.data;
          } else {
            this.fornecedores = res.data;
          }
        })
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    buscaCategorias(autocomplete = null) {
      const parametros = {
        autocomplete,
      };
      return this.planejamentoAcaoResource.buscarCategoria(parametros)
        .then((res) => {
          this.listaCategorias = res.data;
        });
    },
    buscaProdutos(autocomplete = null) {
      const parametros = {
        autocomplete,
      };
      if (this.filtroSellout.grupoFornecedor) {
        parametros.idGrupoFornecedor = this.filtroSellout.grupoFornecedor.id;
      }
      if (this.filtroSellout.categoria) {
        parametros.idCategoria = this.filtroSellout.categoria.id;
      }
      if (this.filtroSellout.fornecedor) {
        parametros.idFornecedor = this.filtroSellout.fornecedor.id;
      }
      return this.planejamentoAcaoResource.buscarProdutosPorCategoria(parametros)
        .then((res) => {
          this.listaProdutos = res.data;
        });
    },
    validarIntervalo() {
      if (this.dateRange.length === 2) {
        let [inicio, fim] = this.dateRange.map((date) => new Date(date));
        if (inicio > fim) {
          [inicio, fim] = [fim, inicio];
        }
        const diffDias = Math.ceil((fim - inicio) / (1000 * 60 * 60 * 24));
        if (diffDias > 60) {
          this.$toast(this.$t('errors.data.selecao_invalida_entre_intervalo_de_datas'));
          this.dateRange = [];
        }
      }
    },

    exibirExportacao(nota) {
      if (nota.tipo === 'INCONSISTENCIA') {
        return false;
      }
      return true;
    },
    abrirModalConfirmacao(acao, nota) {
      if (acao === 'exportar') {
        if ((this.isSellin(nota) && !this.months.length) || (this.isSellout(nota) && !this.dateRange.length)) {
          this.$toast(this.$t('errors.data.obrigatoria'));
          return;
        }
        if ((this.isSellout(nota) && (this.filtroSellout.grupoFornecedor === null || this.filtroSellout.categoria === null))) {
          this.$toast(this.$t('errors.campos_obrigatorios.nao_informados'));
          return;
        }
        if ((this.isSellout(nota) && (this.filtroSellout.grupoFornecedor === null || this.filtroSellout.categoria === null))) {
          this.$toast(this.$t('errors.campos_obrigatorios.nao_informados'));
          return;
        }
        this.bloquearBotaoExportacao = true;
        this.notaSelecionada = nota;
        this.mensagemConfirmacao = this.$t('message.deseja_exportar');
        setTimeout(() => this.$refs.modalConfirmacao.open());
      }
    },
    fecharModalCalendario(index) {
      if (this.menu[index] !== undefined) {
        this.$set(this.menu, index, false);
      }
      this.$forceUpdate();
    },
    confirmaExportacao() {
      if (this.isSellout(this.notaSelecionada)) {
        if (this.dateRange.length === 0) {
          this.$toast(this.$t('message.erro_intervalo_obrigatorio'));
          return;
        }
      }
      const filtro = this.isSellout(this.notaSelecionada) ? this.filtroSellout : this.filtroSellin;
      const formatoData = (date) => date.toISOString().split('T')[0].replace(/-/g, '');
      const intervaloDatasDiaMes = this.isSellout(this.notaSelecionada)
        ? this.dateRange.map((date) => formatoData(new Date(date)))
        : null;
      const meses = !this.isSellout(this.notaSelecionada)
        ? this.months.map((mes) => parseInt(mes.split('-').join(''), 10))
        : null;
      const tipoNota = this.isSellout(this.notaSelecionada)
        ? this.filtroSellout.tipoNota
        : this.filtroSellin.tipoNota;
      const dataFormatada = this.isSellout(this.notaSelecionada)
        ? intervaloDatasDiaMes
        : meses;
      const { tipoData } = filtro;
      const idFornecedor = filtro.fornecedor ? filtro.fornecedor.id : null;
      const idGrupoFornecedor = filtro.grupoFornecedor ? filtro.grupoFornecedor.id : null;
      const idCategoria = filtro.categoria ? filtro.categoria.id : null;
      const idsProdutos = this.listaProdutosSelecionados ? this.listaProdutosSelecionados.map((produto) => produto.id) : null;

      if (!this.exportacaoAssincrona) {
        this.resources.verificarDadosExportacao({
          tipoNota,
          dataFormatada,
          tipoData,
          idFornecedor,
          idGrupoFornecedor,
          idCategoria,
          idsProdutos,
        })
          .then((response) => {
            this.pararEsperar();
            if (response.body) {
              this.$emit('TABELA_EXPORTAR_DADOS',
                () => { this.bloquearBotaoExportacao = false; },
                this.notaSelecionada,
                tipoNota,
                dataFormatada,
                tipoData,
                idFornecedor,
                idGrupoFornecedor,
                idCategoria);
            } else {
              this.bloquearBotaoExportacao = false;
              this.$toast(this.$t('message.sem_dados_exportacao_periodo'));
            }
          }).catch((err) => {
            this.pararEsperar();
            this.$error(this, err);
          }).finally(() => {
            this.bloquearBotaoExportacao = false;
            this.months = [];
            this.dateRange = [];
          });
      } else {
        const params = {
          diaMes: intervaloDatasDiaMes,
          anoMes: meses,
          tipoData,
          tipoNota,
          idFornecedor,
          idGrupoFornecedor,
          idCategoria,
          idsProdutos,
        };
        verificarDadosExportacao(params, this.$resource).then((response) => {
          this.pararEsperar();
          if (response.body) {
            this.executarExportacaoAssincrona(params);
          } else {
            this.bloquearBotaoExportacao = false;
            this.$toast(this.$t('message.sem_dados_exportacao_periodo'));
          }
        }).catch((err) => {
          this.pararEsperar();
          this.$error(this, err);
        }).finally(() => {
          this.bloquearBotaoExportacao = false;
          this.months = [];
          this.dateRange = [];
        });
      }
    },
    executarExportacaoAssincrona(params) {
      executarExportacao(params, this.$resource)
        .then(() => {
          this.pararEsperar();
          this.bloquearBotaoExportacao = false;
          this.$toast(this.$t('message.exportacao_em_andamento_notificacao_email'));
        }, (err) => {
          this.pararEsperar();
          this.bloquearBotaoExportacao = false;
          this.$error(this, err);
        });
    },
    cancelarExportacao() {
      this.bloquearBotaoExportacao = false;
      this.notaSelecionada = {};
    },
    verificaExportacaoAssincrona() {
      this.configSistemaResource.buscarChave({ chave: 'EXPORTACAO_ASSINCRONA' })
        .then((resp) => {
          this.exportacaoAssincrona = resp.body;
        });
    },
    setTipoNota() {
      if (this.isAmbienteMagalu) {
        return 'SELLIN_POR_LINHA';
      }
      return 'SELLIN_POR_NF_ITEM';
    },
    setProduto(hit) {
      if (!hit) return;
      window.setTimeout(() => {
        this.filtroNomeProduto = '';
      });
      this.listaProdutosSelecionados.push(hit);
    },
    removerProdutoPeloId(id) {
      this.listaProdutosSelecionados = this.listaProdutosSelecionados.filter((div) => div.id !== id);
      this.$forceUpdate();
    },
    validaListaProduto(item) {
      return this.listaProdutosSelecionados.find((e) => e.id === item.id);
    },
  },
  mounted() {
    this.verificaExportacaoAssincrona();
  },
};
</script>

<style scoped>
.Container_Nivel1_Notas .Container_Cards {
  padding: 1em 4px 7px 4px;
}
.Container_Nivel1_Notas .Card_Recebimento {
  min-height: 9.5em;
}
.Container_Nivel1_Notas .Card_Title, .Container_Nivel1_Notas .Card_Content {
  color: #757575;
  text-align: center;
  display: block;
  padding: 0;
}
.Container_Nivel1_Notas .Card_Title p {
  font-size: 1.1em;
  font-weight: 500;
  padding: 0;
  margin: 0px;
}
.Container_Nivel1_Notas .Card_Content p {
  font-size: 1.5em;
  font-weight: 300;
  padding: 0.3em;
  margin: 0px;
}
.Container_Nivel1_Notas .Card_Actions {
  min-height: 1em;
}
.Container_Nivel1_Notas .Card_Actions button {
  color: dimgray;
}
.clickable {
  cursor: pointer;
}
.botaoInconsistencia {
  height: 2em !important;
  width: 2em !important;
  font-size: small !important;
  color: white !important;
}
.custom-menu {
  right: 0 !important;
}

.scroll-container {
  border-left: 1px solid #ccc;
  padding-left: 10px;
  max-height: 300px;
}

.custom-autocomplete::v-deep {
  border-radius: 6px 6px 0 0;
}

.scroll-content {
  max-height: 100%;
  overflow-y: auto;
}
</style>
